<div class="footer">
  <div class="font-11 copy-wrapper flex-space-between">
    <span>
      Copyright ©  SPS s.r.l. • Tutti i diritti riservati. 
      P.IVA e CF 09472950014 - R.E.A. 1054866 - CAPITALE SOCIALE € 100.000,00 i.v. - PEC <a href="mailto:spsautomazione@pec.it">spsautomazione@pec.it</a>
    </span>

    <!-- Inizio Codice ShinyStat NEW -->
    <span class="d-none">
      <script src="//codice.shinystat.com/cgi-bin/getcod.cgi?USER=SS-48880081-59efd"></script>
      <noscript>
        <a href="https://www.shinystat.com/it/" target="_top">
          <img src="//www.shinystat.com/cgi-bin/shinystat.cgi?USER=SS-48880081-59efd" alt="Statistiche web" style="border:0px" /></a>
      </noscript>
    </span>
    <!-- Fine Codice ShinyStat -->
  </div>
  <span class="link-wrapper">
    <div class="d-inline-b mr-3"><a routerLink="/privacy" target="_blank">Privacy</a></div>
    <div class="d-inline-b mr-3"><a routerLink="/cookies" target="_blank">Cookies</a></div>
    <div class="d-inline-b ml-4" (click)="openModal()">
      <a routerLink="/homepage"  class="menu">{{"Lavora con noi"|translate}}</a>
    </div>
    <div class="d-inline-b ml-4">
      <a routerLink="/login"  class="menu">Amministrazione</a>
    </div>
  </span>
</div>

<div class="modal modal-work" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-title mb-2 text-right">
          <!-- {{"Lavora con noi"|translate}} -->
          <img class="cursor" src="assets/img/close.svg" width="10" data-dismiss="modal">
        </div>
        <div class="modal-text font-12">
          <app-work-with-us></app-work-with-us>           
        </div>
      </div>
    </div>
  </div>
</div>